import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  // 支払い方法を選択してPOST処理を実行する
  post(e) {
    e.preventDefault();
    const payment_method = $('input[name="order_form[payment_method]"]:checked').val();
    const button = e.target;
    button.disabled = true;
    if (payment_method === "credit") {
      // クレジットカード決済の場合は、先着・抽選関係なくSBPS連携を行う
      $("#OrderFormCreditTrigger").click();
    } else if (payment_method === "cvs") {
      // コンビニ決済の場合は、先着・抽選関係なくFormPostを実行する
      e.target.form.submit();
    } else if (payment_method === "atone") {
      // あと払い・先着の場合pre_purechase処理の後にあと払いModelを開始させる
      // あと払い・抽選の場合は、FormPostを実行する
      const orderType = e.currentTarget.getAttribute("data-order-type");
      if (orderType == "normal") {
        $("#OrderFormAtoneTrigger").click();
      } else {
        e.target.form.submit();
      }
    } else {
      e.target.form.submit();
    }
    // button.disabled = false;
  }

  // あと払い当選後
  winnerPost(e) {
    e.preventDefault();
    const payment_method = $('input[name="winner_purchase_form[payment_method]"]:checked').val();
    const button = e.target;
    button.disabled = true;
    if (payment_method === "credit") {
      // クレジットカード決済の場合は、先着・抽選関係なくSBPS連携を行う
      $("#OrderFormCreditTrigger").click();
    } else if (payment_method === "cvs") {
      // コンビニ決済の場合は、先着・抽選関係なくFormPostを実行する
      e.target.form.submit();
    } else if (payment_method === "atone") {
      $("#OrderFormAtoneTrigger").click();
    } else {
      e.target.form.submit();
    }
    // button.disabled = false;
  }
}
